// Calendar dates must not shift when a visitor is in another time zone.
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export function gameDay(value, fallbackYear) {
  if (!value) return '—';
  const text = String(value).trim();
  if (/T.*(?:Z|[+-]\d{2}:?\d{2})$/.test(text)) {
    const instant = new Date(text);
    if (!Number.isFinite(instant.getTime())) return '—';
    return new Intl.DateTimeFormat('en-US', { weekday: 'long', timeZone: 'America/New_York' }).format(instant);
  }
  let year, month, day;
  let match = text.match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:$|[ T])/);
  if (match) [, year, month, day] = match;
  else {
    match = text.match(/^(\d{1,2})\/(\d{1,2})(?:\/(\d{2}|\d{4}))?$/);
    if (!match) return '—';
    [, month, day, year] = match;
    year = year || fallbackYear;
    if (String(year).length === 2) year = 2000 + Number(year);
  }
  year = Number(year); month = Number(month); day = Number(day);
  if (!Number.isInteger(year) || year < 1900 || year > 2200) return '—';
  const date = new Date(Date.UTC(year, month - 1, day));
  if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return '—';
  return DAYS[date.getUTCDay()];
}
